if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButtons = this.getSubmitButtons();

        if (document.querySelector('cart-drawer'))
          this.submitButtons.forEach((btn) => btn.setAttribute('aria-haspopup', 'dialog'));

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButtons.some((btn) => btn.getAttribute('aria-disabled') === 'true')) return;

        this.handleErrorMessage();

        this.submitButtons.forEach((btn) => {
          btn.setAttribute('aria-disabled', true);
          btn.classList.add('loading');
          btn.querySelector('.loading__spinner').classList.remove('hidden');
        });

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              this.submitButtons.forEach((btn) => {
                const submitButtonText = btn.querySelector('span');
                const soldOutMessage = btn.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                btn.setAttribute('aria-disabled', true);
                submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              });
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButtons.forEach((btn) => {
              btn.classList.remove('loading');
              if (!this.error) btn.removeAttribute('aria-disabled');
              btn.querySelector('.loading__spinner').classList.add('hidden');
            });
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButtons(disable = true, text) {
        const priceElement =
          document.querySelector('.price__sale .price-item--sale') ||
          document.querySelector('.price__regular .price-item--regular');
        const formattedPrice = priceElement ? `(${priceElement.textContent.trim()})` : '';
        const label = disable && text ? text : window.variantStrings.addToCart;

        this.submitButtons.forEach((btn) => {
          const submitButtonText = btn.querySelector('span');
          const showPrice = submitButtonText.classList.contains('show-price');

          if (showPrice) {
            if (!btn._priceNode) {
              btn._priceNode = document.createElement('span');
              btn._priceNode.className = 'product-form__price';
            }
            if (!btn._labelNode) {
              submitButtonText.textContent = '';
              btn._labelNode = document.createTextNode('');
              submitButtonText.append(btn._labelNode, ' ', btn._priceNode);
            }

            const currentLabel = btn._labelNode.nodeValue || '';
            const currentPrice = btn._priceNode.textContent || '';

            if (currentLabel === label && currentPrice === formattedPrice) {
              return;
            }

            btn._labelNode.nodeValue = label;
            btn._priceNode.textContent = formattedPrice;
          } else {
            const currentLabel = submitButtonText.textContent || '';

            if (currentLabel === label) {
              return;
            }

            submitButtonText.textContent = label;
          }

          btn.toggleAttribute('disabled', disable);
        });
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      getSubmitButtons() {
        const buttons = [];
        const internalButton = this.form.querySelector('[type="submit"][name="add"]');
        if (internalButton) buttons.push(internalButton);
        document
          .querySelectorAll(`button[type="submit"][form="${this.form.getAttribute('id')}"]`)
          .forEach((btn) => buttons.push(btn));
        return buttons;
      }
    }
  );
}
